import React from 'react';
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';
import GoogleLogin from 'react-google-login';
import AppleLogin from 'react-apple-login';
import { Button } from 'antd';
import { userConstants } from 'app/constants/user.constants';
import { setStateUserEnter } from 'app/actions/Users/user.enter.action';
import { loginIsLogin, loginModalOpen } from 'app/actions/Login/login.action';
import './loginForm.css';
import { FormattedMessage } from 'react-intl';
import {
  isIOS,
  isMacOs,
  isIOS13,
  isIPhone13,
  isIPad13,
  isIPod13,
} from 'react-device-detect';
import { AppleOutlined } from '@ant-design/icons';
import {
  REGISTER,
  START_LOGIN,
  ACCEPT_LEGAL_ISSUES,
  USER_NOT_REGISTERED,
} from '../../../../constants/enter.user.constants';
import userEnterStore from '../userEnter.service';
import { openNotificationWithIcon } from '../../../Utility/notificationMessage';
import userAPI from '../../../../API/user.service.api';
import { FacebookIcon, GoogleIcon } from './socialIcons';

const getAppleURL = () => `${process.env.API_URL}/api/login.appleCallback`;

const SocialButtons = ({ goTo }) => {
  const success = (user) => ({ type: userConstants.LOGIN_SUCCESS, user });
  const loginSuccess = (data, dispatch, params) => {
    if (data.response && data.response.userdata) {
      const { userdata } = data.response;
      if (userdata.legal_issues) {
        userEnterStore.set(userdata);
        dispatch(success(userdata));

        dispatch(loginIsLogin(true));
        dispatch(loginModalOpen(false));
        dispatch(setStateUserEnter({ name: START_LOGIN }));
      } else {
        const {
          email,
          facebook_id = null,
          google_id = null,
        } = data.response.userdata;
        const state = {
          name: ACCEPT_LEGAL_ISSUES,
          userEmail: email,
          apiMethod: params.apiMethod,
        };
        if (facebook_id) state.facebook_id = facebook_id;
        if (google_id) state.google_id = google_id;

        dispatch(setStateUserEnter(state));
      }
    } else if (
      data &&
      data.code === 400 &&
      data.message === USER_NOT_REGISTERED
    ) {
      const state = {
        name: REGISTER,
        userEmail: params.login,
      };
      if (params.facebook_id) state.facebook_id = params.facebook_id;
      if (params.google_id) state.google_id = params.google_id;
      if (params.imageUrl) state.imageUrl = params.imageUrl;
      dispatch(setStateUserEnter(state));
    } else {
      console.log('login was failed', data);
    }
  };

  const loginError = (err) => {
    console.info(err);
    openNotificationWithIcon('error', err.message);
    // dispatch(failure(err));
    // dispatch(alertActions.error(err));
  };

  const loginViaFacebook = (dispatch, params) => {
    params.apiMethod = 'loginWebViaFacebook';
    userAPI
      .login(params)
      .then((data) => loginSuccess(data, dispatch, { ...params }), loginError);
  };

  const loginViahGoogle = (dispatch, params) => {
    params.apiMethod = 'loginWebViaGoogle';
    userAPI
      .login(params)
      .then((data) => loginSuccess(data, dispatch, { ...params }), loginError);
  };
  // function request(user) { return { type: userConstants.LOGIN_REQUEST, user } }
  // function failure(error) { return { type: userConstants.LOGIN_FAILURE, error } }
  //   const test = (dispatch) => {
  //     const state = {
  //       name: REGISTER,
  //       // userEmail: 'kushnirdv@ukr.net',
  //       userEmail: '',
  //       facebook_id: 'ssssss',
  //     };
  //     dispatch(setStateUserEnter(state));
  //   };
  //   const updateAvatar = () => {
  //     const userID = '1879954838742002';
  //     // const url = 'https://platform-lookaside.fbsbx.com/platform/profilepic/?asid=1879954838742002&height=100&width=100&ext=1582109096&hash=AeRQpqNPf-6M-ro6'
  //     const url = `https://graph.facebook.com/v2.3/${userID}/picture?type=normal`;
  //     userAPI.updateAvararFromURL(url).then((resp) => {
  //       console.log('resp my', resp);
  //     });
  //   };

  const responseFacebook = (resp) => {
    // goTo( null, test );
    // updateAvatar();
    // console.log(resp);
    // return; //uncoment these three rows to test on the server

    console.log(
      resp.email,
      resp.token_for_business,
      resp.first_name,
      resp.last_name,
      resp
    ); // resp.picture.data
    const params = {
      facebook_id: resp.token_for_business,
      imageUrl: `https://graph.facebook.com/v5.0/${resp.userID}/picture?type=normal`,
    };
    if (resp.email) params.login = resp.email;
    goTo(null, loginViaFacebook, params);
  };
  const responseGoogle = (resp) => {
    // console.log(resp);
    // console.log(resp.getAuthResponse());
    const profile =
      resp && typeof resp.getBasicProfile === 'function'
        ? resp.getBasicProfile()
        : null;
    if (profile && typeof profile.getId === 'function') {
      console.log('getBasicProfile', profile);
      console.log('getEmail', profile.getEmail());
      console.log('getFamilyName', profile.getFamilyName());
      console.log('getGivenName', profile.getGivenName());
      console.log('getId', profile.getId());
      console.log('getImageUrl', profile.getImageUrl());

      const login = profile.getEmail();
      const imageUrl = profile.getImageUrl();
      goTo(null, loginViahGoogle, { login, google_id: login, imageUrl });
    } else {
      console.info(resp);
    }
  };
  const isMac = () =>
    navigator.platform.toUpperCase().indexOf('MAC') >= 0 ||
    /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);
  const isAppleIdAvailable = () =>
    isIOS ||
    isMacOs ||
    isIOS13 ||
    isIPhone13 ||
    isIPad13 ||
    isIPod13 ||
    isMac();
  const buttonStyle = isAppleIdAvailable() ? { width: 94 } : {};
  return (
    <>
      <div className="divider">
        <span>
          <FormattedMessage
            id="Or continue with"
            defaultMessage="Or continue with"
          />
        </span>
      </div>
      <div className="login-social-buttons">
        <FacebookLogin
          // appId="772192649914597"
          appId={process.env.FACEBOOK_APP_ID}
          autoLoad={false}
          xfbml
          disableMobileRedirect
          // fields="id,email,first_name,last_name,picture"
          fields="token_for_business,id,email,first_name,last_name"
          callback={responseFacebook}
          render={(renderProps) => (
            <Button
              type="primary"
              className="facebook-primary-button"
              style={buttonStyle}
              onClick={renderProps.onClick}
            >
              <FacebookIcon className="facebook-icon" />
              Facebook
            </Button>
          )}
        />
        <GoogleLogin
          clientId={process.env.GOOGLE_CLIENT_ID}
          render={(renderProps) => (
            <Button
              type="primary"
              className="google-primary-button"
              style={buttonStyle}
              onClick={renderProps.onClick}
            >
              <GoogleIcon className="google-icon" />
              Google
            </Button>
          )}
          onSuccess={responseGoogle}
          onFailure={responseGoogle}
          cookiePolicy="single_host_origin"
        />
        {isAppleIdAvailable() && (
          <AppleLogin
            clientId={process.env.APPLE_CLIENT_ID}
            responseType="code id_token"
            responseMode="form_post"
            redirectURI={getAppleURL()}
            scope="name email"
            render={(renderProps) => (
              <Button
                type="primary"
                className="apple-primary-button"
                onClick={renderProps.onClick}
              >
                <AppleOutlined className="apple-icon" />
                <span className="apple-button-text">Apple</span>
              </Button>
            )}
          />
        )}
      </div>
    </>
  );
};

export default SocialButtons;
